import React from "react";
import { createPortal } from "react-dom";

export default function PdfModal({ src, onClose }) {
  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="relative rounded-lg shadow-lg w-11/12 h-5/6">
        <button
          onClick={onClose}
          className="absolute top-16 right-4 text-xl font-bold"
        >
          ×
        </button>
        <object
          data={src}
          type="application/pdf"
          className="w-full h-full rounded-b-lg"
        >
          <p>
            Não foi possível exibir o PDF.{" "}
            <a href={src} target="_blank" rel="noreferrer">
              Abra em outra aba
            </a>
          </p>
        </object>
      </div>
    </div>,
    document.body
  );
}
